import { Colors } from "@/enums/Colors";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import noEmail from "../../../../assets/images/no-email.svg";
import plus from "../../../../assets/images/whiteplus.svg";

interface EmptyChatsScreenProps {
  handleStartChatFromEmpty: React.MouseEventHandler<HTMLButtonElement>;
  /** Read-only history surface (embedded "Historial" tab): never offers starting a new chat. */
  readOnly?: boolean;
}

export function EmptyChatsScreen({ handleStartChatFromEmpty, readOnly = false }: EmptyChatsScreenProps) {
  const { t } = useTranslation("chat");
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors.ACCENT_F1F3FF,
        position: "relative",
        width: "100%",
        height: "100%",
        flexDirection: "column",
      }}
    >
      <img src={noEmail.src} alt="background" style={{ width: "19.563rem", height: "auto", zIndex: 1 }} />

      <Typography
        sx={{
          fontWeight: "600",
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
          textAlign: "center",
          marginTop: "1.5rem",
          marginBottom: "0.75rem",
        }}
      >
        {readOnly ? t("emptyChatsScreen.readOnlyTitle") : t("emptyChatsScreen.title")}
      </Typography>

      <Typography
        sx={{
          color: Colors.LIGHT_GRAY_8A8E93,
          fontWeight: "400",
          fontSize: "0.875rem",
          lineHeight: "1.225rem",
          maxWidth: "24.125rem",
          textAlign: "center",
          marginBottom: "1.5rem",
        }}
      >
        {readOnly ? t("emptyChatsScreen.readOnlyDescription") : t("emptyChatsScreen.description")}
      </Typography>
      {/* Read-only history never starts a new conversation — new chats live in the Messages tab. */}
      {!readOnly && (
        <Button
          onClick={handleStartChatFromEmpty}
          sx={{
            textTransform: "none",
            backgroundColor: Colors.BUTTON_PURPLE,
            color: Colors.WHITE,
            fontWeight: "600",
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            "&:hover": {
              backgroundColor: Colors.BUTTON_HOVER_PURPLE,
            },
            padding: "0.75rem 1rem 0.75rem 1rem",
            gap: "0.5rem",
            width: "8.563rem",
            height: "2.75rem",
            borderRadius: "0.5rem",
          }}
        >
          {t("emptyChatsScreen.startChatButton")} <img alt={"plus"} src={plus.src} />
        </Button>
      )}
    </Box>
  );
}
